<script lang="ts">
  import type { BrandMark } from '../lib/branding.svelte';

  let {
    mark,
    size = 'md',
  }: {
    mark: BrandMark;
    size?: 'sm' | 'md' | 'lg';
  } = $props();

  const sz = $derived(size === 'lg' ? 52 : size === 'sm' ? 32 : 44);
</script>

{#if mark.kind === 'logo' && mark.logoUrl}
  <div class="logo-wrap" class:sm={size === 'sm'} class:lg={size === 'lg'}>
    <img src={mark.logoUrl} alt="" class="logo-img" />
  </div>
{:else}
  <div
    class="avatar"
    class:sm={size === 'sm'}
    class:lg={size === 'lg'}
    style="--mark-color: {mark.color}; --mark-accent: {mark.accentColor}"
    title={mark.orgLabel}
  >
    <span class="initials">{mark.initials}</span>
    <span class="badge" aria-hidden="true">{mark.emoji}</span>
  </div>
{/if}

<style>
  .logo-wrap {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    box-shadow: 0 1px 4px rgb(15 23 42 / 6%);
  }
  .logo-wrap.sm { width: 32px; height: 32px; border-radius: 8px; }
  .logo-wrap.lg { width: 52px; height: 52px; border-radius: 14px; }
  .logo-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  .avatar {
    position: relative;
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: linear-gradient(145deg, var(--mark-color), var(--mark-accent));
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px color-mix(in srgb, var(--mark-color) 35%, transparent);
  }
  .avatar.sm { width: 32px; height: 32px; border-radius: 8px; }
  .avatar.lg { width: 52px; height: 52px; border-radius: 14px; }

  .initials {
    font-family: Poppins, Inter, system-ui, sans-serif;
    font-weight: 700;
    font-size: 0.95rem;
    color: #fff;
    letter-spacing: -0.02em;
    line-height: 1;
  }
  .avatar.sm .initials { font-size: 0.72rem; }
  .avatar.lg .initials { font-size: 1.1rem; }

  .badge {
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 1.15rem;
    height: 1.15rem;
    font-size: 0.62rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 999px;
    border: 1.5px solid var(--border);
    box-shadow: 0 1px 3px rgb(0 0 0 / 12%);
  }
  .avatar.sm .badge { width: 0.95rem; height: 0.95rem; font-size: 0.52rem; bottom: -2px; right: -2px; }
</style>
